/* eslint-disable no-underscore-dangle */
import { trackTask } from "src/utils/monitoring/events/tasks";
import { registerHandler } from "../handler";
import { MedProductType } from "src/utils/constants";

declare const window: Window & {
  _tfa: any;
};

export default function registerHandlers() {
  registerHandler("lead", () => {
    if (window._tfa) {
      const task = trackTask("trackTaboolaLead");
      try {
        task.start();
        window._tfa.push({
          notify: "event",
          name: "lead",
          id: 1101615,
        });
        task.success();
      } catch (err) {
        task.failed(err);
      }
    }
  });

  registerHandler("purchase", ({ order }) => {
    if (window._tfa) {
      const task = trackTask("trackTaboolaPurchase");
      try {
        task.start();
        window._tfa.push({
          notify: "event",
          name: "make_purchase",
          id: 1101615,
          revenue: order.eltv_13_months.toFixed(3),
        });
        task.success();
      } catch (err) {
        task.failed(err);
      }
    }
  });

  registerHandler("purchaseIntent", ({ estimatedValue, medProductType }) => {
    if (window._tfa && medProductType !== MedProductType.HRT) {
      const task = trackTask("trackTaboolaPurchaseIntent");
      try {
        task.start();
        window._tfa.push({
          notify: "event",
          name: "purchase_glp1",
          id: 1101615,
          revenue: estimatedValue,
        });
        task.success();
      } catch (err) {
        task.failed(err);
      }
    }
  });
}
